module.exports = __webpack_public_path__ + "static/media/Алексеев А.В..d9f1e73a.pdf";